module.exports = __webpack_public_path__ + "img/android_download_btn.f2f4ff18.png";